import React from 'react'

import { AnimatePresence } from 'motion/react'

import {
  CardAllocated,
  type CardAllocatedAction,
  type CardAllocatedData,
  type CardAllocatedLabels,
  type CardAllocatedOptions,
  type CardAllocatedTimeFormat,
  type CardAllocateState,
} from '@/components/molecules/CardAllocated/CardAllocated.tsx'
import { type CardListState, cardStateInList } from '@/components/organisms/CardList/CardListState.ts'
import { cn } from '@/lib/utils.ts'

export type CardListAllocatedTimeFormat = CardAllocatedTimeFormat

export type CardListAllocatedOptions = CardAllocatedOptions

export interface CardListAllocatedLabels extends CardAllocatedLabels {}

export type CardListAllocatedData = Array<CardAllocatedData & { id: string }>

export interface CardListAllocatedActions {
  onActivate: (id: string) => void
  onCancelRequest: (id: string, ...args: Parameters<CardAllocatedAction['onCancelRequest']>) => void
  onCustomerTakenCareOf: (id: string, ...args: Parameters<CardAllocatedAction['onCustomerTakenCareOf']>) => void
  onCustomerNotFound: (id: string, ...args: Parameters<CardAllocatedAction['onCustomerNotFound']>) => void
  onPutOnHold: (id: string, ...args: Parameters<CardAllocatedAction['onPutOnHold']>) => void
}

export interface CardListAllocatedProps
  extends
    React.HtmlHTMLAttributes<HTMLDivElement>,
    CardListAllocatedTimeFormat,
    CardListAllocatedActions,
    Pick<CardAllocateState, 'size'> {
  labels: CardListAllocatedLabels
  options: CardListAllocatedOptions
  data?: CardListAllocatedData
  state?: CardListState
}

export const CardListAllocated = React.forwardRef<HTMLDivElement, CardListAllocatedProps>(
  (
    {
      className,
      labels,
      options,
      data = [],
      state,
      size,
      timeAgoFormatter,
      onActivate,
      onCancelRequest,
      onCustomerTakenCareOf,
      onCustomerNotFound,
      onPutOnHold,
      ...props
    },
    ref
  ) => (
    <div className={cn('flex flex-col', className)} ref={ref} {...props}>
      <AnimatePresence initial={false}>
        {data.map((card) => (
          <CardAllocated
            {...card}
            key={card.id}
            labels={labels}
            options={options}
            size={size}
            state={cardStateInList(card.id, state)}
            highlighted={state?.highlighted === card.id}
            timeAgoFormatter={timeAgoFormatter}
            onClick={() => {
              if (!['selected', 'disabled'].includes(cardStateInList(card.id, state))) {
                onActivate(card.id)
              }
            }}
            onCancelRequest={(value) => {
              onCancelRequest(card.id, value)
            }}
            onPutOnHold={(value) => {
              onPutOnHold(card.id, value)
            }}
            onCustomerTakenCareOf={() => {
              onCustomerTakenCareOf(card.id)
            }}
            onCustomerNotFound={(value) => {
              onCustomerNotFound(card.id, value)
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  )
)
